import moment from 'moment';
import { dateFormat } from './dateTimeFormats';

export const valorReal = "R$ 0,00";
export const valorRealServidor = "R$0,00";



export const compareDates = (a: string, b: string, format: string = dateFormat) => {
  const aMomentDate = moment(a, format);
  const bMomentDate = moment(b, format);
  return aMomentDate.isBefore(bMomentDate) ? -1 : 1;
};

export const compareText = (a: string, b: string) => {

  if (a == undefined) {
    a = "";
  }

  if (b == undefined) {
    b = "";
  }

  return a.localeCompare(b);
};

export const compareNumber = (a: string, b: string) => {
  let valorA = parseInt(a, 10);
  let valorB = parseInt(b, 10);

  if (isNaN(valorA) || isNaN(valorB)) return 0;
  return valorA - valorB;
};

export const compareTypeNumber = (a: number, b: number) => {
  if (a && b)
    return compareNumber(a.toString(), b.toString());
  return 0;
};

export const compareCurrencyValue = (a: string, b: string) => {
  let valorAReplace = a.replace('R$ ', '');
  let valorBReplace = b.replace('R$ ', '');

  valorAReplace = valorAReplace.replace(',', '');
  valorBReplace = valorBReplace.replace(',', '');

  valorAReplace = valorAReplace.replace('.', '');
  valorBReplace = valorBReplace.replace('.', '');

  let valorA = parseInt(valorAReplace, 20);
  let valorB = parseInt(valorBReplace, 20);

  if (isNaN(valorA) || isNaN(valorB)) {
    return 0;
  }
  return valorA - valorB;
};

export const compareCurrencyDecimal = (a: number, b: number) => {
  if (isNaN(a) || isNaN(b)) {
    return 0;
  }
  return a - b;
};

export const compareBool = (a: boolean, b: boolean) => {
  if (a)
    return 1;

  return 0;
};
